class SalonMap {
  container;
  map;
  defaultLat;
  defaultLng;
  latitude;
  longitude;
  defaultZoom;
  zoomLocality;
  zoomMarkerClick;
  salonDetailsEnabled;
  autocomplete = null;
  salons = [];
  filters = [];
  salonsList;
  salonsListParent;
  salonListHtml = "";
  infoWindow;
  dontLoadSalons = false;
  mapStyles = [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    { featureType: "landscape.man_made", stylers: [{ color: "#8a8a8a" }] },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [{ color: "#dfddde" }],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry.fill",
      stylers: [{ color: "#78b64b" }, { saturation: -70 }, { lightness: 70 }],
    },
    {
      featureType: "landscape.natural.landcover",
      elementType: "geometry.fill",
      stylers: [{ color: "#dfddde" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    { featureType: "poi.park", stylers: [{ visibility: "on" }] },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ color: "#78b74b" }, { saturation: -65 }, { lightness: 40 }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.icon",
      stylers: [
        { color: "#78b74b" },
        { saturation: -45 },
        { lightness: 35 },
        { visibility: "off" },
      ],
    },
    {
      featureType: "poi.sports_complex",
      elementType: "geometry.fill",
      stylers: [{ color: "#78b74b" }, { saturation: -65 }, { lightness: 40 }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dadada" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.fill",
      stylers: [{ color: "#ededed" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.stroke",
      stylers: [
        { color: "#d1d1d1" },
        { saturation: -15 },
        { lightness: 60 },
        { visibility: "simplified" },
      ],
    },
    {
      featureType: "road.local",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#c9c9c9" }],
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [{ color: "#cde5fe" }, { saturation: -50 }, { lightness: -10 }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
  ];
  constructor(section) {
    this.container = section;
    this.map = this.container.querySelector("#store-map");
    this.defaultLat = parseFloat(
      this.container.getAttribute("data-default-lat"),
    );
    this.defaultLng = parseFloat(
      this.container.getAttribute("data-default-lng"),
    );
    this.defaultZoom = parseInt(
      this.container.getAttribute("data-default-zoom"),
    );
    this.zoomLocality = parseInt(
      this.container.getAttribute("data-zoom-locality"),
    );
    this.zoomMarkerClick = parseInt(
      this.container.getAttribute("data-zoom-marker-click"),
    );
    this.salonsPerView = parseInt(
      this.container.getAttribute("data-salons-per-view"),
    );
    this.salonDetailsEnabled =
      this.container.getAttribute("data-salon-details") === "true";
    this.pagination = new Pagination(
      this.container.querySelector(".store-map__pager"),
      this.salonsPerView,
    );
    this.salonsList = this.container.querySelector("[store-map-salons-list]");
    this.salonsListParent = this.salonsList.parentElement;
    this.userPosition = new UserPosition();
    this.datalayerEvents = new DatalayerEvents();
  }
  async init() {
    await this.setUserCoordinates(false);
    this.initMap();
    this.initSearchAutoComplete();
    this.initFindMyPositionEvent();
    this.initFilters();
    this.initPaginationEvents();
    this.initSwitchMapListEvents();
  }
  /**
   * Initialize map and get salons when
   * map is in idle state
   *
   * @return {Void}
   */
  initMap() {
    if (this.map) {
      const userLocEmpty = this.userPosition.isUserLocEmpty(),
        centerCoords = userLocEmpty
          ? new google.maps.LatLng(this.defaultLat, this.defaultLng)
          : new google.maps.LatLng(
            this.userPosition.lat,
            this.userPosition.lng,
          );
      this.map = new google.maps.Map(this.map, {
        center: centerCoords,
        zoom: userLocEmpty ? this.defaultZoom : this.zoomLocality,
        disableDefaultUI: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        gestureHandling: "greedy",
        styles: this.mapStyles,
      });
      this.infoWindow = new google.maps.InfoWindow({ disableAutoPan: true });
      //set user position marker
      this.setMarker(
        this.userPosition.lat,
        this.userPosition.lng,
        "You",
        middleware["salonsLocator"]["svg"]["myPosition"],
      );
      //recalculate salons every time map is in idle state
      google.maps.event.addListener(this.map, "idle", async () => {
        if (!this.dontLoadSalons) {
          this.pagination.currentPage = 1;
          await this.getSalons();
        }
        this.dontLoadSalons = false;
      });
    }
  }
  /**
   * Set initial coordinates:
   * get user position coordinates,
   * set it in map and show address in search input
   * @param {Boolean} setMapCenter
   *
   * @return {Void}
   */
  async setUserCoordinates(setMapCenter) {
    if (this.userPosition.isUserLocEmpty()) {
      await this.userPosition.getGeoPosition();
    }
    if (setMapCenter) {
      this.setMapCenter(
        new google.maps.LatLng(this.userPosition.lat, this.userPosition.lng),
        this.zoomLocality,
      );
    }
  }
  /**
   * Initialize Search autocomplete input
   *
   * @return {Void}
   */
  initSearchAutoComplete(result) {
    const input = this.container.querySelector("[store-map-search]");
    const options = { types: ["geocode"] };
    this.autocomplete = new google.maps.places.Autocomplete(input, options);
    this.setAutoCompleteEvent(input);
    this.datalayerEvents.salonClickSearch(result);
  }
  /**
   * Add listener when place change and
   * set place coordinates
   *
   * @return {Void}
   */
  setAutoCompleteEvent(searchInput) {
    google.maps.event.addListener(
      this.autocomplete,
      "place_changed",
      async () => {
        const place = this.autocomplete.getPlace();
        const address = searchInput.value;
        let originLocation = null;
        // if user enter the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        if (!place.geometry) {
          await new Promise((resolve, reject) => {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: address }, function (results, status) {
              if (status == "OK") {
                const lat = results[0].geometry.location.lat();
                const lng = results[0].geometry.location.lng();
                originLocation = new google.maps.LatLng(lat, lng);
                resolve();
              } else reject(error);
            });
          }).catch((error) => console.warn(error));
        } else {
          originLocation = place.geometry.location;
        }
        this.datalayerEvents.salonClickSearch(searchInput.value);
        this.setMapCenter(originLocation, this.zoomLocality);
      },
    );
  }
  /**
   * Initialize geo localization position button
   *
   * @return {Void}
   */
  initFindMyPositionEvent() {
    let self = this;
    self.container
      .querySelector(".store-map__geo-search-btn")
      .addEventListener("click", () => {
        self.setUserCoordinates(true);
        self.datalayerEvents.salonClickSearch("near_me");
      });
  }
  /**
   * store all filters and set events
   *
   * @return {Void}
   */
  initFilters() {
    let self = this;
    self.container.querySelectorAll(".store-map__filter").forEach((filter) => {
      const filterObject = new Filter(filter);
      self.initSalonFilterEvent(filterObject);
      self.filters.push(filterObject);
    });
    self.initOpenFiltersEvents();
  }
  /**
   * Set 'change' filters event and
   * update active options
   *
   * @return {Void}
   */
  initSalonFilterEvent(filter) {
    let self = this;
    filter.options.forEach((option) => {
      option.addEventListener("change", async () => {
        if (option.checked) {
          filter.activeOptions.push(option.value);
        } else {
          filter.activeOptions = filter.activeOptions.filter((activeOption) => {
            return activeOption != option.value;
          });
        }
        this.datalayerEvents.selectSalonType(filter);
        await self.getSalons();
      });
    });
  }
  /**
   * Set toggle filter open events
   *
   * @return {Void}
   */
  initOpenFiltersEvents() {
    let self = this;
    const filtersWrapper = self.container.querySelector(
      ".store-map__wrapper-filter",
    ),
      legendWrapper = self.container.querySelector(
        ".store-map__wrapper-legend",
      );
    if (filtersWrapper != null) {
      filtersWrapper.addEventListener("click", () => {
        if (legendWrapper != null) {
          legendWrapper.classList.remove("open");
          self.container
            .querySelector(".salon_filter__legend")
            .classList.remove("active");
        }
        self.container
          .querySelector(".store-map__wrapper-filter")
          .classList.toggle("open");
        self.container
          .querySelector(".salon_filter__items")
          .classList.toggle("active");
      });

      document.addEventListener("click", (event) => {
        const salonLegendItems = self.container.querySelector(".salon_filter__legend");
        const salonFilterItems = self.container.querySelector(".salon_filter__items");
        if (
          !filtersWrapper.contains(event.target) &&
          (salonFilterItems == null || !salonFilterItems.contains(event.target))
        ) {
          filtersWrapper.classList.remove("open");
          if (salonFilterItems != null) {
            salonFilterItems.classList.remove("active");
          }
        }
        if (
          !legendWrapper.contains(event.target) &&
          (salonLegendItems == null || !salonLegendItems.contains(event.target))
        ) {
          legendWrapper.classList.remove("open");
          if (salonLegendItems != null) {
            salonLegendItems.classList.remove("active");
          }
        }
      });

      self.container
        .querySelectorAll(".store-map__filter-title")
        .forEach((element) => {
          element.addEventListener("click", (event) => {
            // Chiudi tutte le altre attive
            self.container.querySelectorAll(".store-map__filter-title.active").forEach((activeElement) => {
              if (activeElement !== element) {
                activeElement.classList.remove("active");
                activeElement.nextElementSibling.classList.remove("active");
              }
            });

            // Attiva/disattiva l'elemento cliccato
            element.classList.toggle("active");
            event.stopPropagation();
            element.nextElementSibling.classList.toggle("active");
          });
        });
    }
    if (legendWrapper != null) {
      legendWrapper.addEventListener("click", () => {
        if (filtersWrapper != null) {
          filtersWrapper.classList.remove("open");
          self.container
            .querySelector(".salon_filter__items")
            .classList.remove("active");
        }
        legendWrapper.classList.toggle("open");
        self.container
          .querySelector(".salon_filter__legend")
          .classList.toggle("active");
        self.datalayerEvents.salonClickLegend();
      });
    }
  }
  /**
   * When click on pagination buttons
   * load next or previous salons
   *
   * @return {Void}
   */
  initPaginationEvents() {
    let self = this;
    self.pagination.prevButton.addEventListener("click", async () => {
      self.pagination.currentPage--;
      await self.getSalons();
    });
    self.pagination.nextButton.addEventListener("click", async () => {
      self.pagination.currentPage++;
      await self.getSalons();
    });
  }
  initSwitchMapListEvents() {
    let self = this;
    self.container
      .querySelector("#store-map-switches .store-map-switches__switch__map")
      .addEventListener("click", () => {
        self.dontLoadSalons = true;
        self.container
          .querySelector("#store-map__map-container")
          .classList.remove("visible");
        self.container
          .querySelector(".store-map__map-canvas")
          .classList.remove("not-visible");
        self.salonsList.classList.remove("visible");
        self.container
          .querySelector(".store-map__pager")
          .classList.remove("visible");
        self.container
          .querySelector("#store-map__map-container")
          .classList.add("visible");
        self.container
          .querySelector(".store-map-switches__switch__salons")
          .classList.remove("visible");
        self.container
          .querySelector(".store-map-switches__switch__map")
          .classList.add("visible");
      });
    self.container
      .querySelector("#store-map-switches .store-map-switches__switch__salons")
      .addEventListener("click", () => {
        self.dontLoadSalons = true;
        self.container
          .querySelector("#store-map__map-container")
          .classList.remove("visible");
        self.container
          .querySelector(".store-map__pager")
          .classList.remove("visible");
        self.salonsList.classList.add("visible");
        self.container
          .querySelector(".store-map__map-canvas")
          .classList.add("not-visible");
        self.container
          .querySelector(".store-map__pager")
          .classList.add("visible");
        self.container
          .querySelector(".store-map-switches__switch__salons")
          .classList.add("visible");
        self.container
          .querySelector(".store-map-switches__switch__map")
          .classList.remove("visible");
      });
  }
  /**
   * get all salons fetch and create salon boxes
   *
   * @return {Void}
   */
  async getSalons() {
    let self = this;
    const params = self.createSalonParams();
    await fetch(`${middleware["salonsLocator"]["apiUrl"]}/salons?${params}`)
      .then((response) => {
        if (response.ok) return response.json();
        return Promise.reject(response);
      })
      .then((data) => {
        const newSalonIDs = data.rows.map((salon) => salon.id);
        self.removeSalonMarkers(newSalonIDs);
        const salonIDs = self.salons.map((salon) => salon.id);
        data.rows.forEach((salon) => {
          let salonObject = new Salon(salon, self.salonDetailsEnabled);
          if (!salonIDs.includes(salonObject.id)) {
            salonObject.marker = self.setMarker(
              salonObject.latitude,
              salonObject.longitude,
              salonObject.name,
              salonObject.markerIcons[salonObject.type],
            );
            self.initMarkerEvents(salonObject);
            self.salons.push(salonObject);
          }
          self.salonListHtml += salonObject.salonBoxHtml;
        });
        self.container.querySelector(
          "[store-map-salons-found] span",
        ).innerHTML =
          `${data.count} ${middleware["salonsLocator"]["labels"]["itemsFound"]}`;
        self.salonsList.innerHTML = self.salonListHtml;
        self.salonsListParent.scrollTop = 0;
        self.initSalonBoxEvents();
        self.pagination.adjustPagination(data.count);
      })
      .catch((error) => console.warn("Something went wrong.", error));
  }
  /**
   * create params needed for get salon fetch
   *
   * @return {URLSearchParams}
   */
  createSalonParams() {
    let self = this;
    const visibleRadius = self.getMapVisibleRadius();
    self.setCoordinates(self.map.getCenter().lat(), self.map.getCenter().lng());
    //standard params to make fetch works
    let params = {
      latitude: self.latitude,
      longitude: self.longitude,
      radius: visibleRadius,
      division: middleware["salonsLocator"]["division"],
      campaign: "",
      type: "",
      page: self.pagination.currentPage,
      rows: self.salonsPerView,
    };
    self.filters.forEach((filter) => {
      if (filter.activeOptions.length > 0 && !filter.checkAllActiveOptions()) {
        params[filter.name] = filter.joinActiveOptions();
      }
    });
    return new URLSearchParams(params);
  }
  /**
   * init mouseover highlights marker,
   * mouseleave remove highlight marker,
   * click highlight marker and zoom map
   *
   * @return {Void}
   */
  initSalonBoxEvents() {
    let self = this;
    self.salonsList
      .querySelectorAll(".store-map__salon-box")
      .forEach((salonBox) => {
        salonBox.addEventListener("mouseover", (event) => {
          const salon = self.salons.find(
            (item) => item.id == salonBox.getAttribute("data-salon-id"),
          );
          self.highlightMarker(salon, true);
        });
        salonBox.addEventListener("mouseleave", (event) => {
          if (!event.currentTarget.classList.contains("active")) {
            const salon = self.salons.find(
              (item) => item.id == salonBox.getAttribute("data-salon-id"),
            );
            self.highlightMarker(salon, false);
          }
        });
        salonBox.addEventListener("click", (event) => {
          self.resetHighlightedMarkers();
          const salon = self.salons.find(
            (item) => item.id == salonBox.getAttribute("data-salon-id"),
          );
          if (event.target.tagName.toLowerCase() !== "a") {
            event.currentTarget.classList.add("active");
            self.salonsListParent.scrollTop = event.currentTarget.offsetTop;
            self.highlightMarker(salon, true);
            if (window.innerWidth < 798) {
              self.setInfoWindow(salon);
            }
            self.dontLoadSalons = true;
            self.setMapCenter(
              new google.maps.LatLng(salon.latitude, salon.longitude),
              self.zoomMarkerClick,
            );
            // this.datalayerEvents.salonClick(salon.name, 'list');
          } else {
            event.preventDefault();
            //We make sure the event is pushed then relocate to the correct page
            this.datalayerEvents.salonDetailsClick(
              event.target.getAttribute("data-action"),
              salon.name,
              salon.type,
            );
            window.location.href = event.target.href;
          }
        });
      });
  }
  /**
   * set marker events: click opens infoWindow on mobile
   * highlight marker and zoom map
   * @param {Salon} salon
   *
   * @return {Void}
   */
  initMarkerEvents(salon) {
    let self = this;
    salon.marker.addListener("click", () => {
      self.resetHighlightedMarkers();
      const salonBoxActive = self.salonsList.querySelector(
        `.store-map__salon-box[data-salon-id="${salon.id}"]`,
      );
      salonBoxActive.classList.add("active");
      if (window.innerWidth < 798) {
        if (typeof window.goToPos === "function")
          goToPos("#store-map-switches");
        self.setInfoWindow(salon);
      }
      self.dontLoadSalons = true;
      self.highlightMarker(salon, true);
      self.salonsListParent.scrollTop = salonBoxActive.offsetTop;
      self.setMapCenter(
        new google.maps.LatLng(salon.latitude, salon.longitude),
        self.zoomMarkerClick,
      );
      // this.datalayerEvents.salonClick(salon.name, 'placeholder');
    });
  }
  /**
   * set marker in map
   * @param {Number} lat
   * @param {Number} lng
   * @param {String} title
   * @param {String} icon
   *
   * @return {Object}
   */
  setMarker(lat, lng, title, icon) {
    return new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: this.map,
      title: title,
      icon: icon,
    });
  }
  /**
   * Remove salons markers from map
   * except presents in next search
   * @param {Array} newSalonsId
   *
   * @return {Void}
   */
  removeSalonMarkers(newSalonsId) {
    let self = this;
    if (self.salons.length > 0) {
      self.salons = self.salons.filter((salon) => {
        if (newSalonsId.includes(salon.id)) {
          self.highlightMarker(salon, false);
          return true;
        }
        salon.marker.setMap(null);
        return false;
      });
      self.salonListHtml = "";
    }
  }
  /**
   * set bigger or smaller marker image
   * @param {Salon} salon
   * @param {Boolean} highlight
   *
   * @return {Void}
   */
  highlightMarker(salon, highlight) {
    let icon = {
      url: salon.markerIcons[salon.type].url,
      scaledSize: new google.maps.Size(31, 40),
    };
    if (highlight) {
      icon = {
        url: salon.markerIcons[salon.type].url,
        scaledSize: new google.maps.Size(55, 70),
      };
    }
    salon.marker.setIcon(icon);
  }
  /**
   * reset all highlighted markers in map
   *
   * @return {Void}
   */
  resetHighlightedMarkers() {
    let self = this;
    self.salonsList
      .querySelectorAll(".store-map__salon-box.active")
      .forEach((activeSalon) => {
        const activeSalonObject = self.salons.find(
          (item) => item.id == activeSalon.getAttribute("data-salon-id"),
        );
        self.highlightMarker(activeSalonObject, false);
        activeSalon.classList.remove("active");
      });
  }
  /**
   * create and open marker infoWindow
   * @param {Salon} salon
   *
   * @return {Void}
   */
  setInfoWindow(salon) {
    let self = this;
    self.infoWindow.setContent(
      salon.salonBoxHtml
        .replace(
          "<li",
          `<div${salon.place_id != "" ? ` data-salon-details-click` : ""}`,
        )
        .replace("</li>", "</div>"),
    );
    self.infoWindow.open(self.map, salon.marker);
    document.addEventListener("click", (event) => {
      if (
        event.target.closest("[data-salon-details-click]") != null &&
        event.target.tagName.toLowerCase() !== "a"
      ) {
        window.location.href = salon.createSalonDetailsLink();
      }
    });
  }
  /**
   * calculate radius of visible part of the map
   *
   * @return {Number}
   */
  getMapVisibleRadius() {
    const bounds = this.map.getBounds(),
      center = this.map.getCenter();
    if (bounds && center) {
      const ne = bounds.getNorthEast();
      // Calculate radius (in kilometers).
      return (
        google.maps.geometry.spherical.computeDistanceBetween(center, ne) / 1000
      );
    }
    return 0;
  }
  /**
   * set coordinates in map
   * @param {Number} lat
   * @param {Number} lng
   *
   * @return {Void}
   */
  setCoordinates(lat, lng) {
    if (this.latitude !== lat) this.latitude = lat;
    if (this.longitude !== lng) this.longitude = lng;
  }
  /**
   * set center of map and zoom
   * @param {Object} coordinates
   * @param {Number} zoom
   *
   * @return {Void}
   */
  setMapCenter(coordinates, zoom) {
    this.map.setCenter(coordinates);
    this.map.setZoom(zoom);
  }
}
class Pagination {
  #pager;
  #pageCounter;
  #prevButton;
  #nextButton;
  #nPages = 1;
  #currentPage = 1;
  #salonsPerView;
  constructor(pager, salonsPerView) {
    this.#pager = pager;
    this.#pageCounter = this.#pager.querySelector(
      "[store-map-page-counter] span",
    );
    this.#prevButton = this.#pager.querySelector("button[store-map-prev-page]");
    this.#nextButton = this.#pager.querySelector("button[store-map-next-page]");
    this.#salonsPerView = salonsPerView;
  }
  get pager() {
    return this.#pager;
  }
  set pager(value) {
    this.#pager = value;
  }
  get prevButton() {
    return this.#prevButton;
  }
  set prevButton(value) {
    this.#prevButton = value;
  }
  get nextButton() {
    return this.#nextButton;
  }
  set nextButton(value) {
    this.#nextButton = value;
  }
  get nPages() {
    return this.#nPages;
  }
  set nPages(value) {
    this.#nPages = value;
  }
  get currentPage() {
    return this.#currentPage;
  }
  set currentPage(value) {
    this.#currentPage = value;
  }
  get salonsPerView() {
    return this.#salonsPerView;
  }
  disablePrevButton() {
    this.#prevButton.setAttribute("disabled", "");
  }
  enablePrevButton() {
    this.#prevButton.removeAttribute("disabled");
  }
  disableNextButton() {
    this.#nextButton.setAttribute("disabled", "");
  }
  enableNextButton() {
    this.#nextButton.removeAttribute("disabled");
  }
  /**
   * Update the page counter values
   * @param {Number} salonsCount
   *
   * @return {Void}
   */
  updatePageCounter(salonsCount) {
    let nSalonsFirst = (this.currentPage - 1) * this.salonsPerView,
      nSalonsLast = this.currentPage * this.salonsPerView - 1;
    if (nSalonsLast >= salonsCount) nSalonsLast = salonsCount - 1;
    this.#pageCounter.textContent = `${nSalonsFirst}-${nSalonsLast}`;
  }
  /**
   * Adjust prev and next button pagination
   * based on salon results
   * @param {Number} salonsCount
   *
   * @return {Void}
   */
  adjustPagination(salonsCount) {
    this.updatePageCounter(salonsCount);
    this.nPages = Math.ceil(salonsCount / this.salonsPerView);
    if (this.currentPage == 1) {
      if (salonsCount > this.salonsPerView) {
        this.disablePrevButton();
        this.enableNextButton();
      } else {
        this.disablePrevButton();
        this.disableNextButton();
      }
    } else if (this.currentPage < this.nPages) {
      this.enablePrevButton();
      this.enableNextButton();
    } else {
      this.enablePrevButton();
      this.disableNextButton();
    }
  }
}
class UserPosition {
  #lat;
  #lng;
  get lat() {
    return this.#lat;
  }
  set lat(value) {
    this.#lat = value;
  }
  get lng() {
    return this.#lng;
  }
  set lng(value) {
    this.#lng = value;
  }
  isUserLocEmpty() {
    return this.#lat != null && this.#lng != null ? false : true;
  }
  async getGeoPosition() {
    const geoOptions = {
      enableHighAccuracy: true,
      timeout: 6000, // time in millis when error callback will be invoked
      maximumAge: 0, // max cached age of gps data, also in millis
    };
    await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          if (pos.coords.latitude != 0 && pos.coords.longitude != 0) {
            this.#lat = pos.coords.latitude;
            this.#lng = pos.coords.longitude;
          }
          resolve(pos);
        },
        (err) => {
          reject(err);
        },
        geoOptions,
      );
    }).catch((error) => console.warn(error));
  }
}
class Filter {
  #element;
  #name;
  #resetWhenAllActives;
  #activeOptions = [];
  #options;
  #optionsLength;
  constructor(filter) {
    this.#element = filter;
    this.#name = filter.getAttribute("data-filter-name");
    this.#resetWhenAllActives = filter.hasAttribute(
      "data-filter-reset-all-actives",
    );
    this.#options = filter.querySelectorAll(
      '.store-map__filter-option input[type="checkbox"]',
    );
    this.#optionsLength = this.#options != null ? this.#options.length : 0;
  }
  get element() {
    return this.#element;
  }
  set element(value) {
    this.#element = value;
  }
  get activeOptions() {
    return this.#activeOptions;
  }
  set activeOptions(value) {
    this.#activeOptions = value;
  }
  get name() {
    return this.#name;
  }
  set type(value) {
    this.#name = value;
  }
  get options() {
    return this.#options;
  }
  set options(value) {
    this.#options = value;
  }
  get optionsLength() {
    return this.#optionsLength;
  }
  set optionsLength(value) {
    this.#optionsLength = value;
  }
  joinActiveOptions() {
    return this.activeOptions.join(",");
  }
  checkAllActiveOptions() {
    return this.optionsLength == this.activeOptions.length &&
      this.#resetWhenAllActives
      ? true
      : false;
  }
}
class Salon {
  #address;
  #name;
  #place_id;
  #businessname;
  #city;
  #country;
  #distance;
  #id;
  #latitude;
  #longitude;
  #mail;
  #openingHours;
  #openNow;
  #region;
  #telephone;
  #type;
  #website;
  #zipcode;
  #salonBoxHtml;
  #marker;
  #salonDetailsEnabled;
  #services;
  #markerIcons = {
    "davines salon": { url: middleware["salonsLocator"]["svg"]["davinesPin"] },
    "sustainable beauty partner": {
      url: middleware["salonsLocator"]["svg"]["multibrandPin"],
    },
  };
  #servicesIcons = {
    color: { url: middleware["salonsLocator"]["svg"]["color"] },
    treatment: { url: middleware["salonsLocator"]["svg"]["treatment"] },
    styling: { url: middleware["salonsLocator"]["svg"]["styling"] }
  };
  #servicesEnabled = middleware["salonsLocator"]["services"].split(",");
  constructor(salon, salonDetailsEnabled) {
    this.#address = salon.address;
    this.#businessname = salon.businessname;
    this.#city = salon.city;
    this.#country = salon.country;
    this.#distance = salon.distance;
    this.#id = salon.id;
    this.#latitude = salon.latitude;
    this.#longitude = salon.longitude;
    this.#mail = salon.mail;
    this.#name = salon.name;
    this.#place_id = salon.place_id;
    this.#openingHours = salon.opening_hours;
    this.#openNow = salon.opening_hours?.open_now == true ? true : false;
    this.#region = salon.region;
    this.#telephone = salon.telephone;
    this.#type = salon.type;
    this.#website = this.#createWebsiteUrl(salon.website);
    this.#zipcode = salon.zipcode;
    this.#services = salon.service ? salon.service.split(",") : [];
    this.#salonDetailsEnabled = salonDetailsEnabled;
    this.#salonBoxHtml = this.createSalonBox();
  }
  get address() {
    return this.#address;
  }
  get businessname() {
    return this.#businessname;
  }
  get city() {
    return this.#city;
  }
  get country() {
    return this.#country;
  }
  get distance() {
    return this.#distance;
  }
  get id() {
    return this.#id;
  }
  get latitude() {
    return this.#latitude;
  }
  get longitude() {
    return this.#longitude;
  }
  get mail() {
    return this.#mail;
  }
  get name() {
    return this.#name;
  }
  get place_id() {
    return this.#place_id;
  }
  get openNow() {
    return this.#openNow;
  }
  get region() {
    return this.#region;
  }
  get telephone() {
    return this.#telephone;
  }
  get type() {
    return this.#type;
  }
  get website() {
    return this.#website;
  }
  get zipcode() {
    return this.#zipcode;
  }
  get salonBoxHtml() {
    return this.#salonBoxHtml;
  }
  get marker() {
    return this.#marker;
  }
  get markerIcons() {
    return this.#markerIcons;
  }
  set marker(value) {
    this.#marker = value;
  }
  get servicesIcons() {
    return this.#servicesIcons;
  }
  get servicesEnabled() {
    return this.#servicesEnabled;
  }
  get services() {
    return this.#services;
  }
  #getClosingTime(opening_hours) {
    if (opening_hours == null) return null;
    const d = new Date(),
      day = d.getDay();
    const currentDay = opening_hours?.periods.filter(
      (element) => element?.close?.day === day,
    );
    return currentDay.length > 0
      ? `| ${middleware["salonsLocator"]["labels"]["closeAt"]} ${(parseFloat(currentDay[0]?.close?.time) / 100).toFixed(2).replace(".", ":")}`
      : "";
  }
  #createWebsiteUrl(website) {
    let websiteUrl = website;
    if (websiteUrl !== null) {
      websiteUrl = websiteUrl.toLowerCase();
      if (websiteUrl.startsWith("www.")) websiteUrl = "https://" + websiteUrl;
    }
    return websiteUrl;
  }
  createSalonDetailsLink() {
    return `/pages/salon-details?id=${this.id}&distance=${parseFloat(this.distance).toFixed(1).toString()}`;
  }
  /**
   * create HTML Salon box
   *
   * @return {String}
   */
  createSalonBox() {
    const salonName =
      typeof this.businessname != "undefined" && this.businessname != ""
        ? this.businessname
        : this.name;
    var servicesImages = '';
    var servicesEnabled = this.servicesEnabled;
    this.services.forEach((service) => {
      if (!servicesEnabled.includes(service)) return;
      servicesImages += '<img class="salon-service-img" alt="dav icon" src="' + this.servicesIcons[service].url + '">';
    });

    return `<li class="store-map__salon-box" data-salon-id="${this.id}">
            <div class="store-map__salon-marker">
                <img class="salon-icon" alt="dav icon" src="${this.markerIcons[this.type].url}">
            </div>
            <div class="store-map__salon-content">
                <div class="store-map__salon-header">
                    <span class="store-map__salon-type">${this.type}</span>
                    <div class="store-map__salon-services">${servicesImages.length > 0 ? servicesImages : '<div style="width:30px;height:30px;"></div>'}</div>
                </div>
                <div class="store-map__salon-name">
                    <span>${salonName.toLowerCase()}</span>
                </div>
                <div class="store-map__salon-address">
                    <p>${this.address.toLowerCase()} - ${this.zipcode} ${this.city.toLowerCase()}, ${this.region.toUpperCase()} | ${parseFloat(this.distance).toFixed(1)} km</p>
                    ${this.openNow ? `<p><span class="salon-open">${middleware["salonsLocator"]["labels"]["open"]}</span><span class="salon-close-at"> ${this.#getClosingTime(this.#openingHours)}</span></p>` : ""}
                </div>
                <div class="store-map__salon-info">
                    ${this.#salonDetailsEnabled === true ? "" : `
                    <div class="store-map__salon-call"><img loading="lazy" src="${middleware["salonsLocator"]["svg"]["callUs"]}" alt="callUs" class="store-map__salon-button-img" />
                    <a href="tel:${this.telephone}" data-action="phone-call">${middleware["salonsLocator"]["labels"]["call"]}</a>
                    </div>`
      }
                    <div class="store-map__salon-call"><img loading="lazy" src="${middleware["salonsLocator"]["svg"]["emailUs"]}" alt="emailUs" class="store-map__salon-button-img" />
                        <a href="${this.#salonDetailsEnabled === true ? this.createSalonDetailsLink() : `mailto:${this.mail}`}" data-action="email-contact">${this.#salonDetailsEnabled === true ? middleware["salonsLocator"]["labels"]["call"] : middleware["salonsLocator"]["labels"]["email"]}</a>
                    </div>
                    <div class="store-map__salon-routes"><img loading="lazy" src="${middleware["salonsLocator"]["svg"]["directions"]}" alt="directions" class="store-map__salon-button-img" />
                        <a href="https://www.google.com/maps/dir/?api=1&destination=${this.latitude},${this.longitude}" target="_blank" data-action="get-directions">${middleware["salonsLocator"]["labels"]["direction"]}</a>
                    </div>
                    ${this.#salonDetailsEnabled === true ? `<div class="store-map__salon-call"><img loading="lazy" src="${middleware["salonsLocator"]["svg"]["moreInfo"]}" alt="moreInfo" class="store-map__salon-button-img" />
                    <a href="${this.createSalonDetailsLink()}" data-action="more-info">${middleware["salonsLocator"]["labels"]["moreInfo"]}</a>
                    </div>` : ""}
                </div>
            </div>
        </li>`;
  }
}

class DatalayerEvents {
  constructor() { }
  salonDetailsClick(action, name, type) {
    if (typeof dataLayer != "undefined") {
      dataLayer.push({
        event: "GAevent",
        ss_event_id: GTM.getGtmRandomString(),
        eventID: "26",
        eventCategory: "store_locator",
        eventAction: GTM.formatString(action),
        eventLabel: GTM.formatString(name),
        storeType: GTM.formatString(type),
      });
    }
  }
  salonClickSearch(result) {
    let searchResultGtm = result || "";
    if (typeof dataLayer != "undefined") {
      dataLayer.push({
        event: "GAevent",
        eventID: "22",
        eventCategory: "store_locator",
        eventAction: searchResultGtm,
        eventLabel: "search",
      });
    }
  }
  salonClickLegend() {
    if (typeof dataLayer != "undefined") {
      dataLayer.push({
        event: "GAevent",
        eventID: "54",
        eventCategory: "store_locator",
        eventAction: "legend",
        eventLabel: "click",
      });
    }
  }
  selectSalonType(filter) {
    let eventAction = null;
    let eventId = null;
    let selectedOptionsText = [];
    switch (filter.name) {
      case "campaign":
        eventId = "24";
        eventAction = "campaign_type";
        break;

      case "type":
        eventId = "23";
        eventAction = "salon_type";
        break;

      default:
        break;
    }
    filter.options.forEach((option) => {
      if (option.checked) {
        const gtmLabel = option.getAttribute("data-gtm-label");
        if (gtmLabel != null) {
          selectedOptionsText.push(GTM.formatString(gtmLabel));
        }
      }
    });

    if (
      eventAction !== null &&
      eventId !== null &&
      selectedOptionsText.length > 0
    ) {
      if (typeof dataLayer != "undefined") {
        dataLayer.push({
          event: "GAevent",
          ss_event_id: GTM.getGtmRandomString(),
          eventID: eventId,
          eventCategory: "store_locator",
          eventAction: eventAction,
          eventLabel: selectedOptionsText,
        });
      }
    }
  }
}
